import CoreStoreModule from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'

import { Client as RevasClient } from '@revas/ts-api'
import { AxiosInstance } from 'axios'
import VueI18n from 'vue-i18n'

export default class DesktopsStoreModuleContainer {
  coreStoreModule: CoreStoreModule
  appStoreModule: AppStoreModule
  revasClient: RevasClient
  axios: AxiosInstance
  i18n!: VueI18n | null

  constructor (coreStoreModule: CoreStoreModule, appStoreModule: AppStoreModule, revasClient: RevasClient, axios: AxiosInstance, i18n: VueI18n | null) {
    this.coreStoreModule = coreStoreModule
    this.appStoreModule = appStoreModule
    this.revasClient = revasClient
    this.axios = axios
    this.i18n = i18n
  }
}
